import {ApolloClient, HttpLink, InMemoryCache} from '@apollo/client';
import {Platform} from 'react-native';

import type {StaticConfigurationProvider} from '../StaticConfigurationProvider';
import type {ApolloClientProvider} from './ApolloClientProvider';

export default class ApolloClientProviderImpl
  implements ApolloClientProvider, Disposable
{
  private readonly _stack;
  public readonly client;

  constructor(
    private readonly _root: {
      readonly staticConfigurationProvider: StaticConfigurationProvider;
    },
  ) {
    using stack = new DisposableStack();

    const {staticConfigurationProvider} = _root;
    const link = new HttpLink({
      uri: staticConfigurationProvider.configuration.graphqlApiLocator,
    });

    const cache = new InMemoryCache();
    stack.defer(() => {
      cache.gc({resetResultCache: true});
    });

    const client = new ApolloClient({
      link,
      cache,
      assumeImmutableResults: true,
      devtools: {
        name: 'TwelveXTwelvePressMain',
        enabled: __DEV__ && Platform.OS === 'web',
      },
    });
    stack.defer(() => {
      client.stop();
    });
    this.client = client;

    this._stack = stack.move();
  }

  [Symbol.dispose]() {
    this._stack.dispose();
  }
}
